//'use strict';
try {
    window.$ = window.jQuery = require("jquery");

    require("jquery-ui");
    require("jquery-ui/ui/widgets/sortable");
    require("bootstrap-datepicker");
} catch (e) {}
